import * as React from 'react';

function SvgEdit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
      <path d="M4.78 14.45v2.77h2.77l7.9-7.9-2.78-2.76-7.9 7.89zM17.9 6.88c.3-.29.3-.75 0-1.04L16.16 4.1a.74.74 0 00-1.04 0l-1.45 1.46 2.77 2.77 1.46-1.45z" />
    </svg>
  );
}

export default SvgEdit;
